<template>
  <div>
    <b-table-simple class="table my-2">
      <b-thead>
        <b-tr>
          <b-th scope="col">From</b-th>
          <b-th scope="col">to</b-th>
          <b-th scope="col">Score</b-th>
          <b-th scope="col">Action</b-th>
        </b-tr>
      </b-thead>

      <b-tbody>
        <b-tr
          v-for="(cloenFields,index) in $store.state.priConfigrationforms.sanctions.tokenSortCategoryScoreValue"
          :key="index"
        >
          <b-td style="padding-top: 0px;">
            <div v-if="index == 0">1</div>
            <div v-else>{{checkFieldValue(index)}}</div>
          </b-td>
          <b-td>
            <b-form-group :invalid-feedback="invalidValue">
              <b-form-input
                v-model="$store.state.priConfigrationforms.sanctions.tokenSortCategoryScoreValue[index]"
                :state="invalidValue ? false : null"
                onkeydown="return event.keyCode !== 69"
                @change="setArrayValue($event,index)"
                type="number"
                size="sm"
              ></b-form-input>
            </b-form-group>
          </b-td>
          <b-td>
            <b-form-group>
              <b-form-input
                onkeydown="return event.keyCode !== 69"
                v-model="$store.state.priConfigrationforms.sanctions.tokenSortScoreValue[index]"
                type="number"
                size="sm"
                min="31"
                max="75"
              ></b-form-input>
            </b-form-group>
          </b-td>
          <b-td style="padding-top: 0px;">
            <b-button
              variant="outline-danger"
              v-if="index > 0"
              size="sm"
              @click="onDeleteOption(cloenFields)"
            >
              <i class="fa fa-trash"></i>
            </b-button>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>
            <b-button @click="addRowInTokenSortTable">Add Row</b-button>
          </b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
  </div>
</template>
<script>
export default {
  name: "AddRowComponentWithRangeTokenRatio",
  data() {
    return {
      setInputArray: [],
      inputValue: null,
      checkValue: null,
      invalidValue: null,
      categoryIndex: null
    };
  },
  mounted() {},
  computed: {},
  methods: {
    checkFieldValue(index) {
      let value = this.$store.state.priConfigrationforms.sanctions
        .tokenSortCategoryScoreValue[index - 1];
      return parseInt(value) + 1;
    },
    setArrayValue(data, index) {
      this.checkValue = data;
      this.categoryIndex = index;
      this.setInputArray.push(data);
    },
    addRowInTokenSortTable() {
      if (this.setInputArray.length) {
        let data = this.setInputArray[0];
        this.invalidValue = null;
        let tokenSortCategoryScoreValue = this.$store.state.priConfigrationforms
          .sanctions.tokenSortCategoryScoreValue[this.categoryIndex - 1];

        if (parseInt(tokenSortCategoryScoreValue) + 1 > this.checkValue) {
          this.$store.state.priConfigrationforms.sanctions.validInputField = true;
          this.invalidValue = "Value Can't be less then";
          this.setInputArray = [];
          return;
        }
        this.$store.state.priConfigrationforms.sanctions.validInputField = false;
        this.$store.state.priConfigrationforms.sanctions.tokenSortCategoryScoreValue.push(
          parseInt(data) + 2
        );
        this.inputValue = data;
        this.setInputArray = [];
      } else {
        this.$store.state.priConfigrationforms.sanctions.tokenSortCategoryScoreValue.push(
          this.inputValue != null ? parseInt(this.inputValue) + 2 : null
        );
        this.inputValue = null;
      }
    },
    onDeleteOption(value) {
      let tokenSortCategory = this.$store.state.priConfigrationforms.sanctions
        .tokenSortCategoryScoreValue;
      let tokenSortCategoryIndex = tokenSortCategory.indexOf(value);
      tokenSortCategory.splice(tokenSortCategoryIndex, 1);
      this.$store.state.priConfigrationforms.sanctions.tokenSortScoreValue.splice(
        tokenSortCategoryIndex,
        1
      );
    }
  }
};
</script>